import React from 'react';
import { Icon, App, Page, Navbar, Block, Radio, BlockTitle, BlockFooter, Button, Popup, Link, Card, Toggle, List, ListItem, ListInput, Toast} from 'konsta/react';
import {GearAltFill, QrcodeViewfinder} from 'framework7-icons/react';
import CustomQrcodePlugin from './CustomQrcodePlugin.jsx'
import { Buffer } from 'buffer';
import AASInterfaceV2 from './AASInterfaceV2.js'
import AASInterfaceV3 from './AASInterfaceV3.js'


import GitInfo from 'react-git-info/macro';

class MyApp extends React.Component {

    Action = {
        init:        0,
        add:         1,
        remove:      2,
        updateAsset: 3,
        settings:    4
      }

    Popup = {
        open:       0,
        closed:     1,
      }

    Api = {
        v1:         0,
        v2:         1,
        v3:         2
      }

    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback.
        this.onNewScanResult = this.onNewScanResult.bind(this);

        this.backends = 
        [
            { name: "F-X PCF", server: "//plugfest6.aas-voyager.com", api: this.Api.v3, referencePoint: 0, registryPrefix: "", registrySuffix: "", absoluteRegistry: "//plugfest2.aas-voyager.com/shell-descriptors" },
            { name: "IDTA Techday", server: "//techday1-repo1.admin-shell-io.com", api: this.Api.v3, referencePoint: 0, registryPrefix: "", registrySuffix: "", absoluteRegistry: "//techday1-registry.admin-shell-io.com/shell-descriptors" },
            { name: "DPP4@Grid", server: "//energy-data.dpp40-5-v3.industrialdigitaltwin.org", api: this.Api.v3, registryPrefix: "", registrySuffix: "/shell-descriptors", referencePoint: 0 },
            { name: "ZVEI Electrical Installation", server: "//eis-data.dpp40-4-v3.industrialdigitaltwin.org", api: this.Api.v3, registryPrefix: "", registrySuffix: "/shell-descriptors", referencePoint: 1 },
            { name: "Building", server: "//building-data.dpp40-6-v3.industrialdigitaltwin.org", api: this.Api.v3, registryPrefix: "", registrySuffix: "/shell-descriptors", referencePoint: 1 },
            { name: "Level 2 Cabinet Instance 3", server: "//dpp40-3-v2.industrialdigitaltwin.org", api: this.Api.v2, registryPrefix: "registry.", registrySuffix: "/registry/shell-descriptors", referencePoint: 0 },
            { name: "Level 2 Cabinet Instance 2", server: "//dpp40-2-v2.industrialdigitaltwin.org", api: this.Api.v3, registryPrefix: "registry.", registrySuffix: "/shell-descriptors", referencePoint: 0 },
            { name: "Level 1 Cabinet Instance 2", server: "//dpp40-2-v1.industrialdigitaltwin.org/bport", api: this.Api.v1, registryPrefix: "", registrySuffix: "", referencePoint: 0 },
            { name: "Level 1 Cabinet Instance 1", server: "//dpp40-1-v1.industrialdigitaltwin.org/bport", api: this.Api.v1, registryPrefix: "", registrySuffix: "", referencePoint: 0 }//,
            //{ name: "Level 1 Cabinet Instance 1 (fallback)", server: "//zvei-pcf.germanywestcentral.cloudapp.azure.com/bport", api: this.Api.v1 }
        ]

        const search = window.location.search;
        const params = new URLSearchParams(search);

        //default backend settings if no hostname matches below
        this.bootApiVerison = this.Api.v1;
        this.advanced = 0;
        this.registryPrefix = "";
        this.registrySuffix = "";
        this.absoluteRegistry = null;

        this.secret = params.get('s') ? params.get('s') : "";

        //routine to define default hostname
        if(params.get('hostname'))
            this.hostname = params.get('hostname');
        else{
            this.hostname = this.backends[this.backends.length-1].server; //default choice
            var origin = new URL(window.location.href)
            var webiteServer = "//" + origin.host;
            console.log(webiteServer);
            for(const backend of this.backends){
                if(backend.server.indexOf(webiteServer) === 0){
                    this.hostname= backend.server;
                    this.bootApiVerison = backend.api;
                    this.registryPrefix = backend.registryPrefix;
                    this.registrySuffix = backend.registrySuffix;
                    this.advanced = backend.referencePoint;
                    this.absoluteRegistry = 'absoluteRegistry' in backend ? backend.absoluteRegistry : null;
                }
            }
        }

        this.state = {
            action: this.Action.init,
            popup: this.Popup.closed,
            popup_text: "",
            refAssetIdShort: "ZveiControlCabinetAas",
            hostname: this.hostname,
            secret: this.secret,
            advanced: this.advanced,
            api_version: this.bootApiVerison,
            username: "",
            password: "",
            registryPrefix: this.registryPrefix,
            registrySuffix: this.registrySuffix,
            absoluteRegistry: this.absoluteRegistry
        }

        console.log(this.hostname);
        this.submodelIdShort = "BillOfMaterial";
    }

    stopScanning(){
        const list2 = document.querySelectorAll("#stop-button");
        for(const element of list2){  
            //TODO: this is a hacky style to stop scanning -> need to use "html5-qrcode-scanner" component to do it properly 
            if(element.innerHTML === "Stop Scanning"){
                element.click();
            }
        }
    }

    startScanning(){
        const list2 = document.querySelectorAll("#start-button");
        for(const element of list2){  
            //TODO: this is a hacky style to stop scanning -> need to use "html5-qrcode-scanner" component to do it properly 
            if(element.innerHTML === "Start Scanning"){
                element.click();
            }
        }
        
    }

    render() {
        const gitInfo = GitInfo();

        return (
        <App theme="ios">
            <Page>
            <Navbar title="PCF@Control Cabinet Scanner"
                    right={
                        <Link navbar iconOnly>
                          <Icon
                            ios={<GearAltFill className="w-7 h-7" />}
                            material={<GearAltFill className="w-6 h-6" />}
                            onClick={()=>{this.setState({action: this.Action.settings})}}
                          />
                        </Link>
                      }
            />
            {this.state.popup === this.Popup.open && 1==0 &&
            <Block strong inset>
                <div dangerouslySetInnerHTML={{__html: this.state.popup_text}}></div>
            </Block>

            }
            {this.state.popup === this.Popup.open &&
                    <Toast
                    position="center"
                    opened={true}
                    button={
                      <Button clear inline onClick={() => this.setState({popup: this.Popup.close})}>
                        Close
                      </Button>
                    }
                    >
                    <div className="shrink" dangerouslySetInnerHTML={{__html: this.state.popup_text}}></div>
                  </Toast>
            }
            {this.state.action === this.Action.init &&
            <div>
                <Card
                header={
                    <div
                    className="-mx-4 -my-2 h-52 p-4 flex items-end text-white font-bold bg-cover bg-center"
                    style={{
                        backgroundImage:
                        'url(cabinet.png)',
                    }}
                    >
                    <span className="drop-shadow-md">ZVEI PCF@Control Cabinet Demo</span>
                    </div>
                }
                /*footer={
                    <div className="flex justify-between">
                    <Link href="https://zvei.org" target="_new">Read more</Link>
                    </div>
                }*/
                >
                <p>
                    Use this app to change cabinet's configuration
                    and trigger calcuation of its CO<sub>2</sub> footprint.
                </p>
                </Card>
                {this.state.advanced === 1 &&
                <div>
                <BlockTitle className="space-y-2">
                    Reference Asset Administration Shell:
                </BlockTitle>
                <Block strong className="space-y-2">
                    <div className="grid grid-cols-2 gap-x-4">
                    <span>{this.state.refAssetIdShort}</span>
                    <Button large onClick={()=>{this.setState({action: this.Action.updateAsset}, this.startScanning())}}>
                            <Icon
                            ios={<QrcodeViewfinder className="w-9 h-9" />}
                            material={<QrcodeViewfinder className="w-9 h-9" />}
                            className="pr-2"
                            />
                        Update asset
                    </Button>
                    </div>
                </Block>
                </div>
                }
                <BlockTitle className="space-y-2">
                    Select action to update assets's BOM:
                </BlockTitle>
                <Block strong className="space-y-2">
                    <div className="grid grid-cols-2 gap-x-4">
                    <Button large onClick={()=>{this.setState({action: this.Action.add}, this.startScanning())}}>
                        <Icon
                            ios={<QrcodeViewfinder className="w-9 h-9" />}
                            material={<QrcodeViewfinder className="w-9 h-9" />}
                            className="pr-2"
                            />
                        Add <br/>component
                    </Button>
                    <Button large onClick={()=>{this.setState({action: this.Action.remove}, this.startScanning())}}>
                        <Icon
                            ios={<QrcodeViewfinder className="w-9 h-9" />}
                            material={<QrcodeViewfinder className="w-9 h-9" />}
                            className="pr-2"
                        />
                        Remove component
                    </Button>
                    </div>
                </Block>
                <BlockFooter>&copy; {gitInfo.commit.date.slice(0,4)} Sten Grüner - #{gitInfo.commit.shortHash}</BlockFooter>
            </div>
            }
            <Popup opened={this.state.action === this.Action.updateAsset 
                        || this.state.action === this.Action.add
                        || this.state.action === this.Action.remove } 
            onBackdropClick={() => this.setState({action: this.Action.init}, this.stopScanning())}>
                <Page>
                    <Navbar
                        title="Scan asset's Identification Link"
                        right={
                        <Link navbar onClick={() => this.setState({action: this.Action.init}, this.stopScanning())}>
                            Close
                        </Link>
                        }
                    />

                    <CustomQrcodePlugin qrCodeSuccessCallback={this.onNewScanResult}/>
                </Page>
            </Popup>
                
            <Popup opened={this.state.action === this.Action.settings } 
            onBackdropClick={() => this.setState({action: this.Action.init})}>
                <Page>
                    <Navbar
                        title="App settings"
                        right={
                        <Link navbar onClick={() => this.setState({action: this.Action.init})}>
                            Close
                        </Link>
                        }
                    />
                {this.state.api_version === this.Api.v1 && 
                <div>
                <BlockTitle className="space-y-2">
                    Secret:
                </BlockTitle>
                <List strong>
                <ListInput
                type="text"
                placeholder={this.state.secret}
                onChange = {(e)=>{this.setState({secret: e.target.value})}}
                />
                </List>
                </div>
                }
                {(this.state.api_version === this.Api.v2 || this.state.api_version === this.Api.v3) && 
                <div>
                <BlockTitle className="space-y-2">
                    Username:
                </BlockTitle>
                <List strong>
                <ListInput
                type="text"
                value={this.state.username}
                onChange = {(e)=>{this.setState({username: e.target.value})}}
                />
                </List>
                <BlockTitle className="space-y-2">
                    Password:
                </BlockTitle>
                <List strong>
                <ListInput
                type="password"
                value={this.state.password}
                onChange = {(e)=>{this.setState({password: e.target.value})}}
                />
                </List>
                </div>
                }

                <BlockTitle className="space-y-2">
                    DPP4.0 Demonstrator selection:
                </BlockTitle>
                <List strong>
                {this.backends.map((backend, i) => (
                    <ListItem
                    key={`k-${i}`}
                    id={`i-${i}`}
                    title={backend.name}
                    after={ <Toggle
                        checked={this.state.hostname === backend.server}
                        
                        onChange={() => {
                                    this.setState({hostname: backend.server,
                                         api_version: backend.api,
                                         registryPrefix: backend.registryPrefix,
                                         registrySuffix: backend.registrySuffix,
                                         absoluteRegistry: 'absoluteRegistry' in backend ? backend.absoluteRegistry : null,
                                         advanced: backend.referencePoint});
                            }
                        }
                        />
                        }
                    />
                ))}
                </List>
                


                <BlockTitle className="space-y-2">
                    API version (read only):
                </BlockTitle>
                <List strong>
                <ListItem
                    label
                    title="Level 3"
                    media={
                        <Radio
                        readOnly
                        disabled
                        component="div"
                        checked={this.state.api_version === this.Api.v3}
                        onChange={() => this.setState({api_version: this.Api.v3})}
                        />
                    }
                    />
                <ListItem
                    label
                    title="Level 2"
                    media={
                        <Radio
                        readOnly
                        disabled
                        component="div"
                        checked={this.state.api_version === this.Api.v2}
                        onChange={() => this.setState({api_version: this.Api.v2})}
                        />
                    }
                    />
                <ListItem
                    label
                    title="Level 1"
                    media={
                        <Radio
                        readOnly
                        disabled
                        component="div" 
                        checked={this.state.api_version === this.Api.v1}
                        onChange={() => this.setState({api_version: this.Api.v1})}
                        />
                    }
                    />
                </List>

                <BlockTitle className="space-y-2">
                    Advanced features:
                </BlockTitle>
                <List strong>
                <ListItem
                title="Enable Reference Point Selection"
                after={
                    <Toggle
                        checked={this.state.advanced === 1}
                        
                        onChange={() => {
                                if(this.state.advanced===1){
                                    this.setState({advanced: 0});
                                }else{
                                    this.setState({advanced: 1});
                                }
                            }
                        }
                    />}
                    />
                </List>
                </Page>
            </Popup>

            </Page>
        </App>
    );
    }

    showError(text){
        this.setState({popup_text: "<b style='color:red;'>Error:</b> " + text});
        this.showPopup(5);
    }

    showSuccess(text){
        this.setState({popup_text: "<b style='color:green;'>Success:</b> " + text});
        this.showPopup(5);
    }

    showPopup(seconds){
        this.setState({popup: this.Popup.open});
        setTimeout(() => this.setState({popup: this.Popup.close}), seconds*1000);
    }

    onNewScanResult(decodedText, decodedResult) {
        if(this.state.action === this.Action.updateAsset){
            if(this.state.api_version === this.Api.v1){
                this.getAasIdShortAndType(decodedText).then(
                    res => {
                        if('idShort' in res){
                            //check if bom exists
                            this.getIdShortWithinBom("", res.idShort).then((response) =>
                                {
                                    this.setState({refAssetIdShort: res.idShort});
                                    this.showSuccess("Reference asset changed");
                                }
                            ).catch((error) => {
                                console.log(error)
                                this.showError("Asset's AAS has no BOM submodel");

                            });
                        }else{
                            this.showError("No AAS found for the scanned ID");
                        }
                }
                )
            }else if(this.state.api_version === this.Api.v2){
                //not implemented
                this.showError("Not implemented for V2 API");
            }else {
                //v3
                AASInterfaceV3.getAasIdShortAndTypeV3(decodedText, this.buildRegistryUrlV3(this.state.hostname), this.buildAuthHeaderV2).then(res => {
                    //AAS exists
                    if('idShort' in res){
                        //check if bom exists
                        AASInterfaceV3.getIdShortWithinBomV3("", res.idShort, this.buildRegistryUrlV3(this.state.hostname), this.submodelIdShort, this.buildAuthHeaderV2()).then((response) =>
                            {
                                this.setState({refAssetIdShort: res.idShort});
                                this.showSuccess("Reference asset changed");
                            }
                        ).catch((error) => {
                            console.log(error)
                            this.showError("Asset's AAS has no BOM submodel");

                        });
                    }else{
                        this.showError("No AAS found for the scanned ID");
                    }
                });
            }
        }
        if(this.state.action === this.Action.add){
            if(this.state.api_version === this.Api.v1){
                this.getAasIdShortAndType(decodedText).then(res => {
                    //AAS exists
                    if('idShort' in res){
                        const type = res.kind; //type or instance
                        this.getIdShortWithinBom(decodedText, this.state.refAssetIdShort).then(
                            idShort => {
                                //Asset exists already in the bom and is an instance
                                if(idShort!=="" && type === "Instance"){
                                    this.showError("BOM submodel already contains the instance element");
                                }else{
                                //multiple types are okay
                                    this.createAsset(decodedText)
                                    .then(res => {
                                        console.log(res); 
                                        if(res.ok){
                                            this.showSuccess("Element added");
                                        } else {
                                            this.showError("Element insertion failed. Status: " + res.statusText);
                                        }
                                    }).catch(error => {
                                        this.showError("Element insertion failed. Error: " + error);
                                    });
                                }
                            }
                        );
                    }else{
                        this.showError("AAS not found for the scanned Asset ID");
                    }
                });
            }else if(this.state.api_version === this.Api.v2){
                AASInterfaceV2.getAasIdShortAndTypeV2(decodedText, this.buildRegistryUrlV2(this.state.hostname), this.buildAuthHeaderV2).then(res => {
                    //AAS exists
                    if('idShort' in res){
                        const type = res.kind; //type or instance
                        AASInterfaceV2.getIdShortWithinBomV2(decodedText, this.state.refAssetIdShort, this.buildRegistryUrlV2(this.state.hostname), this.submodelIdShort, this.buildAuthHeaderV2()).then(
                            result => {
                                //Asset exists already in the bom and is an instance
                                if(result.idShort!=="" && type === "Instance"){
                                    this.showError("BOM submodel already contains the instance element");
                                }else{
                                //multiple types are okay
                                AASInterfaceV2.createAssetV2(result.endpoint, decodedText, this.buildAuthHeaderV2())
                                    .then(res => {
                                        console.log(res); 
                                        if(res.ok){
                                            this.showSuccess("Element added");
                                        } else {
                                            this.showError("Element insertion failed. Status: " + res.statusText);
                                        }
                                    }).catch(error => {
                                        this.showError("Element insertion failed. Error: " + error);
                                    });
                                }
                            }
                        ).catch(error => {
                            this.showError("Adding element failed. Error: " + error);
                        });
                    }else{
                        this.showError("AAS not found for the scanned Asset ID");
                    }
                }
                ).catch(error => {
                    this.showError("Element insertion failed. Error: " + error);
                });
            } else {
                //V3 add code
                AASInterfaceV3.getAasIdShortAndTypeV3(decodedText, this.buildRegistryUrlV3(this.state.hostname), this.buildAuthHeaderV2).then(res => {
                    //AAS exists
                    if('idShort' in res){
                        const type = res.kind; //type or instance
                        AASInterfaceV3.getIdShortWithinBomV3(decodedText, this.state.refAssetIdShort, this.buildRegistryUrlV3(this.state.hostname), this.submodelIdShort, this.buildAuthHeaderV2()).then(
                            result => {
                                //Asset exists already in the bom and is an instance
                                if(result.idShort!=="" && type === "Instance"){
                                    this.showError("BOM submodel already contains the instance element");
                                }else{
                                //multiple types are okay
                                AASInterfaceV3.createAssetV3(result.endpoint, decodedText, this.buildAuthHeaderV2())
                                    .then(res => {
                                        console.log(res); 
                                        if(res.ok){
                                            this.showSuccess("Element added");
                                        } else {
                                            this.showError("Element insertion failed. Status: " + res.statusText);
                                        }
                                    }).catch(error => {
                                        this.showError("Element insertion failed. Error: " + error);
                                    });
                                }
                            }
                        ).catch(error => {
                            this.showError("Adding element failed. Error: " + error);
                        });
                    }else{
                        this.showError("AAS not found for the scanned Asset ID");
                    }
                }
                ).catch(error => {
                    this.showError("Element insertion failed. Error: " + error);
                });
            }
        }
        if(this.state.action === this.Action.remove){
            if(this.state.api_version === this.Api.v1){
                this.getIdShortWithinBom(decodedText, this.state.refAssetIdShort).then(
                idShort => {
                    if(idShort===""){
                        this.showError("BOM submodel does not contian the element");
                    }else{
                        this.deleteAsset(idShort)
                        .then(res => {
                            console.log(res); 
                            if(res.ok){
                                this.showSuccess("Element removed");
                            } else {
                                this.showError("Element removal failed. Status: " + res.statusText);
                            }
                        }).catch(error => {
                            this.showError("Element removal failed. Error: " + error);
                        });
                    }
                }
                );
            }else if(this.state.api_version === this.Api.v2){
                AASInterfaceV2.getIdShortWithinBomV2(decodedText, this.state.refAssetIdShort, this.buildRegistryUrlV2(this.state.hostname), this.submodelIdShort, this.buildAuthHeaderV2()).then(
                result => {
                    console.log(result);
                    if(result.idShort===""){
                        this.showError("BOM submodel does not contian the element");
                    }else{
                        AASInterfaceV2.deleteAssetV2(result.endpoint, result.idShort, this.buildAuthHeaderV2())
                        .then(res => {
                            console.log(res); 
                            if(res.ok){
                                this.showSuccess("Element removed");
                            } else {
                                this.showError("Element removal failed. Status: " + res.statusText);
                            }
                        });
                    }
                }).catch(error => {
                            this.showError("Element removal failed. Error: " + error);
                });
            }else{
                AASInterfaceV3.getIdShortWithinBomV3(decodedText, this.state.refAssetIdShort, this.buildRegistryUrlV3(this.state.hostname), this.submodelIdShort, this.buildAuthHeaderV2()).then(
                    result => {
                        console.log(result);
                        if(result.idShort===""){
                            this.showError("BOM submodel does not contian the element");
                        }else{
                            AASInterfaceV3.deleteAssetV3(result.endpoint, result.idShort, this.buildAuthHeaderV2())
                            .then(res => {
                                console.log(res); 
                                if(res.ok){
                                    this.showSuccess("Element removed");
                                } else {
                                    this.showError("Element removal failed. Status: " + res.statusText);
                                }
                            });
                        }
                    }).catch(error => {
                                this.showError("Element removal failed. Error: " + error);
                });
            }


        }
        //alert("Here a backend call is expected. Action: " + this.state.action + " with id: " + decodedText);
        this.setState({action: this.Action.init}, this.stopScanning())
    }

    deleteAsset(idShort){
        return fetch(this.state.hostname+"/aas/"+this.state.refAssetIdShort+"/submodels/"+this.submodelIdShort+"/elements/"+idShort+"?s="+this.state.secret, {
            method: 'DELETE'
            })
            //.then(res => res.json());
    }

    createAsset(assetId){
        assetId = decodeURIComponent(assetId);
        return fetch(this.state.hostname+"/aas/"+this.state.refAssetIdShort+"/submodels/"+this.submodelIdShort+"/elements/?first=1&s="+this.state.secret, {
            method: 'PUT',
            headers: {
              'Content-type': 'application/json'
            },
            body: `
                {
                entityType: "SelfManagedEntity",
                asset: {
                keys: [
                {
                type: "Asset",
                local: true,
                value: "`+assetId+`",
                index: 0,
                idType: "IRI"
                }
                ]
                },
                semanticId: {
                keys: [ ]
                },
                constraints: [ ],
                hasDataSpecification: [ ],
                idShort: "`+Date.now()+`",
                category: null,
                modelType: {
                name: "Entity"
                },
                statements: [ ],
                kind: "Instance",
                descriptions: null
                }
            `
          })
          //.then(res => res.json());
    }

    //Returns idShort and Type in object
    getAasIdShortAndType(assetId){
        //console.log("call getAasIdShortAndType");
        assetId = decodeURIComponent(assetId); 
        //console.log("decoded " + assetId);
        return fetch(this.state.hostname+"/server/listasset")
        .then(res => res.json())
        .then(res => {
            //console.log(res);
            for(const elem of res.aaslist){
                const split = elem.split(" : ");
                //console.log(split);
                if(split[4].endsWith(assetId)){
                    return {idShort: split[1], kind: split[5]};
                }
            }
            return {};
        })
    }

    getIdShortWithinBom(assetId, referenceIdShort){
        assetId = decodeURIComponent(assetId);
        return fetch(this.state.hostname+"/aas/"+referenceIdShort+"/submodels/"+this.submodelIdShort+"/complete/")
        .then((response) => {
          //console.log(response);
          if (response.ok) {
            return response;
          }
          //console.log("throwing error");
          throw new Error('Submodel or asset does not exist');
        })
        .then(res => res.json())
        .then(res => {
            for(const elem of res.submodelElements){
                if(elem && elem["asset"] && elem.asset["keys"] && elem.asset.keys.length > 0){
                    if(elem.asset.keys[0]["value"] === assetId){
                        return(elem.idShort);
                    }
                }
            }
            return("");
        }
        );
    }

    buildAuthHeaderV2(){
        let auth = Buffer.from(this.state.username+":"+this.state.password).toString('base64');
        return {
            'Authorization': `Basic ${auth}`
        }
    }

    buildRegistryUrlV2(hostname){
        if(this.state.absoluteRegistry)
            return this.state.absoluteRegistry;
        else
            return hostname.replace("//", "//"+this.state.registryPrefix) + this.state.registrySuffix;
    }

    buildRegistryUrlV3(hostname){
        if(this.state.absoluteRegistry){
            return this.state.absoluteRegistry;
        }else    
            return hostname.replace("//", "//"+this.state.registryPrefix) + this.state.registrySuffix;
    }
};
export default MyApp;
